import { render, staticRenderFns } from "./NewPassFormModal.vue?vue&type=template&id=210ffcfc&scoped=true"
import script from "./NewPassFormModal.vue?vue&type=script&lang=js"
export * from "./NewPassFormModal.vue?vue&type=script&lang=js"
import "./NewPassFormModal.vue?vue&type=style&index=0&id=210ffcfc&prod&scoped=true&lang=scss"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ffcfc",
  null
  
)

export default component.exports